import mobileMainScene from '../assets/scene/main-menu-mobile.png';
import mobileDegreeScene from '../assets/scene/degree-mobile.png';
import mobileDeskScene from '../assets/scene/desk-mobile.png';
import mobileSkillScene from '../assets/scene/skill-mobile.png';
import mobileTvScene from '../assets/scene/tv-mobile.png';
import mobileVinylScene from '../assets/scene/vinyl-mobile.png';
import Credits from './Credits';
import FlashingDot from './FlashingDot';
import Desk from './desk/Desk';
import Degrees from './diplomas/Degrees';
import SkillDisplay from './skills/SkillDisplay';
import Vinyl from './vinyl/Vinyl';
import DoubleNoteAnimated from '../assets/images/notes//DoubleNoteAnimated';
import EighthNoteAnimated from '../assets/images/notes//EighthNoteAnimated';
import { useEffect, useRef, useState } from 'react';
import { CopyrightCircleFilled, VideoCameraFilled } from '@ant-design/icons';
import { FloatButton, Tour } from 'antd';
import Hobbies from './tv/Hobbies';
import { FaMapSigns } from 'react-icons/fa';

const images = {
  'main': mobileMainScene, 
  'diplomas': mobileDegreeScene,
  'skill': mobileSkillScene,
  'tv': mobileTvScene,
  'vinyl': mobileVinylScene,
  'desk': mobileDeskScene
};

const StaticMobileScene = ({ scene, setScene, isFirstLoad }) => {
  
  const [areCreditsVisible, setAreCreditsVisible] = useState(false);
  const [areNotesVisible, setAreNotesVisible] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [tourOpen, setTourOpen] = useState(isFirstLoad);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAreNotesVisible(true);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  const vw = (p) => (p * windowSize.width) / 100;
  const vh = (p) => (p * windowSize.height) / 100;

  const deskObjects = [
    { name: 'bottle', pos: { x: vw(50), y: vh(70) }},
    { name: 'mac-bg', pos: { x: vw(20), y: vh(75) }},
    { name: 'headset', pos: { x: vw(80), y: vh(70) }},
    { name: 'cv', pos: { x: vw(60), y: vh(80) }},
    { name: 'phone-display', pos: { x: vw(70), y: vh(75) }},
    { name: 'socket-grounding-prong', pos: { x: vw(55), y: vh(55) }}
  ];

  const diplomaObjects = [
    { name: 'bac-frame', pos: { x: vw(25), y: vh(57) }},
    { name: 'licence-frame', pos: { x: vw(22), y: vh(80) }},
    { name: 'bachelor-frame', pos: { x: vw(67), y: vh(57) }},
  ];

  const skillObjects = [
    { name: 'teamwork-stand', pos: { x: vw(20), y: vh(50) }},
  ];

  const vinylObjets = [
    { name: 'record-player-spindle', pos: { x: vw(40), y: vh(75) }},
  ];

  const tvObjects = [
    { name: 'declan-rice', pos: { x: vw(50), y: vh(60) }}
  ];

  const steps = [
    {
      title: 'Welcome to my room!',
      description: 'Click on the flashing dots to explore different things around my room.',
      target: () => ref1.current
    },
    {
      title: 'Vinyl Collection',
      description: 'Click on the vinyl to learn more about my favourite songs.',
      target: () => ref2.current
    },
    {
      title: 'Desk',
      description: 'Click on the desk to see my projects and work experience.',
      target: () => ref3.current
    },
    {
      title: 'Degrees',
      description: 'Click on the diplomas to see my academic path.',
      target: () => ref4.current
    },
    {
      title: 'Trophy Case',
      description: 'Click on the trophies to see my software skills.',
      target: () => ref5.current
    },
    {
      title: 'TV',
      description: 'Click on the TV to see some of my hobbies.',
      target: () => ref6.current
    },
    {
      title: '3D Room',
      description: <>Click on the <VideoCameraFilled /> button to switch to the 3D room</>,
      target: () => ref7.current
    }
  ];

  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <img 
        src={images[scene]} 
        alt="Scene"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "fill",
          display: "block"
        }} 
      />
      {scene === 'main' && (
        <>
          <FlashingDot ref={ref3} onClick={() => setScene('desk')} position={{ x: vw(20), y: vh(58) }}/>
          <FlashingDot ref={ref4} onClick={() => setScene('diplomas')} position={{ x: vw(15), y: vh(45) }}/>
          <FlashingDot ref={ref2} onClick={() => setScene('vinyl')} position={{ x: vw(35), y: vh(72) }}/>
          <FlashingDot ref={ref5} onClick={() => setScene('skill')} position={{ x: vw(58), y: vh(46) }}/>
          <FlashingDot ref={ref6} onClick={() => setScene('tv')} position={{ x: vw(68), y: vh(57) }}/>
          {areNotesVisible && (
            <>
              <DoubleNoteAnimated begin={0.3} scale={0.2} duration={3} color={'white'} position={{ x: vw(35) - 30, y: vh(77) - 240 }} />
              <EighthNoteAnimated begin={0.5} scale={0.4} duration={3.5} color={'white'} position={{ x: vw(35), y: vh(77) - 170  }} />
              <EighthNoteAnimated begin={0.5} scale={0.2} duration={3} color={'white'} position={{ x: vw(35), y: vh(77) - 120  }} />
            </>
          )}

          <FloatButton.Group style={{insetInlineEnd: 94,}} >
            <FloatButton ref={ref1} icon={<FaMapSigns />} tooltip='Guide' onClick={() => setTourOpen(true)} />
            <FloatButton icon={<CopyrightCircleFilled />} tooltip='Credits' onClick={() => setAreCreditsVisible(true)} />
          </FloatButton.Group>
          <Credits isModalOpen={areCreditsVisible} setIsModalOpen={setAreCreditsVisible} />
          <Tour open={tourOpen} onClose={() => setTourOpen(false)} steps={steps} />
        </>
      )}
      {scene === 'desk' && <Desk trackedObjects={deskObjects} />}
      {scene === 'diplomas' && <Degrees trackedObjects={diplomaObjects} />}
      {scene === 'skill' && <SkillDisplay trackedObjects={skillObjects} />}
      {scene === 'vinyl' && <Vinyl trackedObjects={vinylObjets} />}
      {scene === 'tv' && <Hobbies trackedObjects={tvObjects} />}
    </div>
  );
}

export default StaticMobileScene;